// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ColumnHeader, ColumnHeaderSchema } from 'api/gen/ColumnHeader';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement, PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema } from 'api/gen/PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement';

const requiredPart = t.interface({
  headers: t.union([t.array(ColumnHeaderSchema), t.null]),
  pagedModel: PagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema,
});

export const DynamicPagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema = excess(requiredPart);

export interface DynamicPagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagement extends t.TypeOf<typeof DynamicPagedModelUserProfileSubjectRoleManagementDtoOtherSubjectRoleManagementSchema> {}
